module.exports = __webpack_public_path__ + "static/media/info-stadium.1c93026e.jpg";